import React from 'react';

import SettingsShell from '../../components/common/SettingsShell';
import { useFinanceSetupItems } from '../../components/finance/setup/useFinanceSetupItems';

/**
 * Finance → Setup. Every money setting in one place, beside the screens it
 * shapes. Items are permission-gated individually; `?item=` deep-links.
 */
const FinanceSetupPage: React.FC = () => (
  <SettingsShell
    title="Finance setup"
    subtitle="How fees are charged, how money is classified, and how the books are kept."
    items={useFinanceSetupItems()}
    emptyDescription="Your role doesn't include any finance settings. Ask an administrator if you need access."
  />
);

export default FinanceSetupPage;
